import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'

import './SideBar.scss';
class SideBar extends Component {

    render() {
        return (
            <aside className="ebs-sidebar overflow-auto">
                <nav className="navbar-sidebar">
                    <ul className={`list-unstyled ebs-navlist${this.props.isOpenMenuAcessoRapido ? '-reduzido' : ''}`}>
                        {this.props.menuItems.map((item, index) => (
                            <li key={index}>
                                {/* <NavLink to="" className="btn btn-link item-group" onClick={() => { this.props.openMenuItem(index) }}> */}
                                {/* <button className="btn btn-link" onClick={() => { this.props.openMenuItem(index) }}> */}
                                <div className="group-item">
                                    <i className={`fas ${item.icon}`}></i> {item.name}
                                </div>
                                {/* </button> */}
                                {/* </NavLink> */}
                                {item.childrens && (
                                    <ul className={`list-unstyled ${item.open ? "d-block" : ""}`}>
                                        {item.childrens.map((child, index) => (
                                            child.inactive ?
                                                <li onClick={this.props.toggleMenuMobile} key={index}>
                                                    <p className="sub-item">{child.name}</p>
                                                </li>
                                                :
                                                <li onClick={this.props.toggleMenuMobile} key={index}>
                                                    <NavLink to={child.path} className="sub-item">{child.name}</NavLink>
                                                </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>
            </aside>
        )
    }
}

export default SideBar;